/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { forwardRef } from 'react';
var imageWrapperStyles = css({
  width: '100vw',
  height: '100vh',
  overflow: 'auto',
  textAlign: 'center',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap'
});
var dynamicImageWrapperStyles = css({
  overflow: 'hidden'
});
export var ImageWrapper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    isHidden = _ref.isHidden;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsx("div", {
      "data-testid": "media-viewer-svg-wrapper",
      onClick: onClick,
      ref: ref,
      css: [imageWrapperStyles, isHidden && dynamicImageWrapperStyles]
    }, children)
  );
});